import { Text } from '@lounge-fe/ui-kit/src/components/Text'
import { CiteProps } from './types'
import { useTimeSince } from '../../../../hooks/useTimeSince'
import { useFeatureFlags } from '@/hooks/useFeatureFlags'
import { useShopify } from '@/hooks/useShopify'
import { useTranslation } from 'react-i18next'

const Cite = ({
  date: dateString,
  author,
  original,
  showOriginal,
  onToggleOriginal,
}: CiteProps) => {
  const { t } = useTranslation()

  const date = useTimeSince(new Date(dateString))

  const handleToggleOriginal = () => {
    if (onToggleOriginal) {
      onToggleOriginal()
    }
  }

  return (
    <div className="flex flex-col">
      <Text variant="body-sm">
        {t('product.reviews.cite', {
          date,
          author,
        })}
      </Text>
      {original?.title != undefined && (
        <Text variant="body-sm">
          <>
            {' '}
            {t('product.reviews.translated_from', {
              language: t(`languages.${original.languageCode}`),
            })}{' '}
            <button className="underline " onClick={handleToggleOriginal}>
              {showOriginal
                ? t('product.reviews.show_translated')
                : t('product.reviews.show_original')}
            </button>
          </>
        </Text>
      )}
    </div>
  )
}

export default Cite
